import script from "./ChannelIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChannelIcon.vue?vue&type=script&lang=ts&setup=true"

import "./ChannelIcon.vue?vue&type=style&index=0&id=5b7c0a77&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b7c0a77"]])

export default __exports__